import { Block } from '@components/core-ui/Block';
import PencilIcon from '@components/icons/Pencil.svg';
import TrashBin from '@components/icons/TrashBin.svg';
import { ModalNamesEnum } from 'app/types/enums/ModalNamesEnum';
import { usePageContext } from '@pages/User/NewJobPage/providers/PageProvider';
import { useAuthContext } from '@providers/AuthProvider';
import { useModalContext } from '@providers/ModalProvider';
import { routes } from '@routes';
import { JobDtoUser } from 'app/API';
import { StyledLink } from './styles/StyledLink';
import { Wrapper } from './styles/Wrapper';

export const ReporterAssigneeBlock = () => {
  const { form, setForm, job, setJob } = usePageContext();
  const { organization } = useAuthContext();
  const { openModal, closeModal } = useModalContext();

  const setAssignee = (assignee: JobDtoUser | null) => {
    setForm({
      ...form,
      item: {
        ...form.item,
        meetingAssigneeId: assignee?.id ?? undefined,
      },
      meetingAssignee: assignee ?? undefined,
    });
    if (job) {
      setJob({
        ...job,
        meetingAssignee: assignee ?? undefined,
      });
    }
    closeModal();
  };

  const assignee = job?.meetingAssignee ?? form.meetingAssignee;

  const editAssignee = () => {
    openModal(ModalNamesEnum.GetAssigneeWithoutCommentModal, {
      initialValue: assignee,
      onSuccess: (newAssignee: JobDtoUser | null) => setAssignee(newAssignee),
    });
  };

  return (
    <Block title="Court reporter assignee *">
      <Wrapper>
        {assignee ? (
          <div className="assignee-wrapper">
            <div className="assignee">
              <StyledLink to={routes.userDetails.make(organization?.slug ?? '', assignee?.id)}>
                <p className="assignName">
                  {assignee?.name} {assignee?.lastname}
                </p>
                <p className="assignEmail">{assignee?.email || ''}</p>
              </StyledLink>
            </div>
            <button className="edit-assignee" type="button" onClick={() => editAssignee()}>
              <PencilIcon className="text-[var(--color-text-muted)] hover:text-[var(--color-accent)] cursor-pointer" />
            </button>
            <button className="remove-assignee" type="button" onClick={() => setAssignee(null)}>
              <TrashBin />
            </button>
          </div>
        ) : null}
        {!assignee ? (
          <button className="add-assignee" type="button" onClick={() => editAssignee()}>
            + Add court reporter assignee
          </button>
        ) : null}
      </Wrapper>
    </Block>
  );
};
